export const gapi = 'https://webapicab.tech:5901'
